import { render, staticRenderFns } from "./dashboard-charts.vue?vue&type=template&id=047c51e7"
import script from "./dashboard-charts.vue?vue&type=script&lang=js"
export * from "./dashboard-charts.vue?vue&type=script&lang=js"
import style0 from "./dashboard-charts.vue?vue&type=style&index=0&id=047c51e7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports